import {
  useNormalizer,
} from '@sttedra_ui/framework';

const {
  getString,
} = useNormalizer();

class RegisterPdfApiRequestModel {
  // #region Props
  mitmaCode;
  identification;
  // #endregion

  constructor(data) {
    this.mitmaCode = getString(data?.mitmaCode);
    this.identification = getString(data?.identification);
  }
}

export default RegisterPdfApiRequestModel;
